import colorAxisFluIndex from './colorAxisAllergiesIndex'
const dataDisplayOptions = [
  {
    label: 'Public Indicators',
    options: [
      {
        value: 'threshold_level',
        tagKey: 'threshold_level',
        tagValue: 'data_value',
        label: 'Incidense Rate',
        colorAxis: colorAxisFluIndex,
        mapTitle: '',
        mapSubTitle: undefined,
        indicatorName: 'Forecasts',
        legend: {
          enabled: false,
          title: {
            text: '',
          },
        },
      },
    ],
  },
]

export default dataDisplayOptions
